export default __webpack_public_path__ + "static/media/15.143a6637.jpg";